import styled from 'styled-components';
import { ButtonGradient } from '../Buttons';
import { ButtonIconWrapper } from '../Buttons/style';

export const CircleCallMeButton = styled(ButtonGradient)`
    width: 42px;
    height: 42px;
    padding: 0;
    margin-left: 20px;
`;

export const CircleIconButtonWrapper = styled(ButtonIconWrapper)`
    margin: 0;
`;